import React, { useState } from 'react';

import SettingsCog from '../../../images/settings-cog.png';
import { ProjectModal } from '../../Modals/ProjectModal/ProjectModal';
import useProject from '../../../hooks/useProject';

import './ProducerSettingsCog.scss';

type ProducerSettingsProps = {
  reloadProject: () => void;
};

const ProducerSettings = ({ reloadProject }: ProducerSettingsProps) => {
  const { project } = useProject();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="producer-settings-cog">
      <button onClick={() => setIsModalOpen(true)} className="producer-settings-cog-button">
        <img src={SettingsCog} className="producer-settings-cog-image" alt="settings icon" />
      </button>

      {isModalOpen && (
        <ProjectModal
          isOpen={isModalOpen}
          contentLabel="Edit Project Details"
          project={project}
          handleCloseModal={() => {
            setIsModalOpen(false);
            reloadProject();
          }}
        />
      )}
    </div>
  );
};

export default ProducerSettings;
